import { useState } from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/sections/HeroSection";
import SummarySection from "@/components/sections/SummarySection";
import ProblemSection from "@/components/sections/ProblemSection";
import SolutionSection from "@/components/sections/SolutionSection";
import MarketSection from "@/components/sections/MarketSection";
import BusinessSection from "@/components/sections/BusinessSection";
import ConnectCertSection from "@/components/sections/ConnectCertSection";
import ScalabilitySection from "@/components/sections/ScalabilitySection";
import CompetitiveSection from "@/components/sections/CompetitiveSection";
import VisionSection from "@/components/sections/VisionSection";
import ArchitectureSection from "@/components/sections/ArchitectureSection";
import OrgChartSection from "@/components/sections/OrgChartSection";
import Footer from "@/components/Footer";

function App() {
  const [lang, setLang] = useState("fr");

  return (
    <div data-testid="ecolunch-app" className="min-h-screen bg-background">
      <Navbar lang={lang} setLang={setLang} />
      <main>
        <HeroSection lang={lang} />
        <SummarySection lang={lang} />
        <ProblemSection lang={lang} />
        <SolutionSection lang={lang} />
        <MarketSection lang={lang} />
        <BusinessSection lang={lang} />
        <ConnectCertSection lang={lang} />
        <ScalabilitySection lang={lang} />
        <CompetitiveSection lang={lang} />
        <VisionSection lang={lang} />
        <ArchitectureSection lang={lang} />
        <OrgChartSection lang={lang} />
      </main>
      <Footer lang={lang} />
    </div>
  );
}

export default App;
